import { useState, useEffect } from 'react';
import {
    getClientCoachMe,
    clientCoachMe,
    importClientCoachMe,
    clientCoachMeStatus,
} from '../../../../redux/slices/clientsSlice';
import { useSelector, useDispatch } from 'react-redux';
import CoachMeTable from './CoachMeTable';
import UploadBox from './UploadBox';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function ClientCoachMeSubPage() {
    const dispatch = useDispatch();
    const params = useParams();
    const coachMe = useSelector(clientCoachMe);
    const coachMeStatus = useSelector(clientCoachMeStatus);
    const [fileLoadErrors, setFileLoadErrors] = useState({
        isWrongFileType: false,
    });

    useEffect(() => {
        dispatch(getClientCoachMe(params.id));
    }, [dispatch, params.id]);

    const uploadCoachMeTable = async (body) => {
        await dispatch(importClientCoachMe({ id: params.id, body })).unwrap();
        await dispatch(getClientCoachMe(params.id)).unwrap();
        toast.success('Table loaded successfully');
    };

    const onFileSelect = async (e) => {
        if (e.target.files && e.target.files[0]) {
            if (
                e.target.files[0].type !==
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ) {
                setFileLoadErrors({ isWrongFileType: true });
                return;
            }
        }

        const fd = new FormData();

        fd.append('coach_me_message', e.target.files[0]);

        await uploadCoachMeTable(fd);
    };

    const onCoachMeTableUpload = async () => {
        const fd = new FormData();
        const input = document.createElement('input');
        input.type = 'file';
        input.addEventListener('change', loadFile);
        input.click();

        async function loadFile(e) {
            if (e.target.files && e.target.files[0]) {
                if (
                    e.target.files[0].type !==
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ) {
                    toast.error('Wrong file type');
                    return;
                }
            }

            fd.append('coach_me_message', e.target.files[0]);
            await uploadCoachMeTable(fd);
        }
    };

    return (
        <>
            {coachMe?.length > 0 && coachMeStatus !== 'loading' && (
                <CoachMeTable
                    data={coachMe}
                    coachMeStatus={coachMeStatus}
                    onCoachMeTableUpload={onCoachMeTableUpload}
                />
            )}
            {coachMe?.length === 0 && coachMeStatus !== 'loading' && (
                <UploadBox
                    onFileSelect={onFileSelect}
                    fileLoadErrors={fileLoadErrors}
                />
            )}
        </>
    );
}
